import * as React from 'react';
import SelectField from '../../common/form-controls/SelectField';
import FieldHandler from '../../../models/interfaces/FieldHandler';
import { AWSEnvironment } from '../../../models/enums/AWSEnvironment';

interface EnvironmentInputProps extends FieldHandler<number> {
	isManaged?: boolean;
}

const EnvironmentInput: React.FC<EnvironmentInputProps> = (props) => {
	return (
		<SelectField
			label="Environment"
			className="full-width"
			options={
				props.isManaged
					? [
							{ text: 'DEV', value: AWSEnvironment.Development.value },
							{ text: 'TST', value: AWSEnvironment.Testing.value },
							{ text: 'PRD', value: AWSEnvironment.Production.value },
						]
					: [
							{ text: 'POC', value: AWSEnvironment.PoC.value },
							{ text: 'TST', value: AWSEnvironment.Testing.value },
							{ text: 'PRD', value: AWSEnvironment.Production.value },
						]
			}
			{...props}
		/>
	);
};

export default EnvironmentInput;
